import React from 'react';
import { Link } from 'react-router-dom';
import { products } from '../data/products';
import './Footer.css';

const COMPANY_LINKS = [
  { to: '/about', label: '회사 소개' },
  { to: '/products', label: '프로덕트' },
  { to: '/blog', label: '블로그' },
  { to: '/contact', label: '문의하기' },
];

const LEGAL_LINKS = [
  { to: '/privacy-policy', label: '개인정보 처리방침' },
  { to: '/terms', label: '이용약관' },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-section--brand">
            <img
              src="/flowto-logo-header.png"
              alt="Flowto.AI"
              className="footer-logo"
            />
            <p className="footer-tagline">
              AI 프로덕트 스튜디오.
              <br />
              일상에서 쓰는 서비스를 만듭니다.
            </p>
            <a className="footer-mail" href="mailto:flowtosupport@gmail.com">
              flowtosupport@gmail.com
            </a>
          </div>

          <div className="footer-section">
            <h2 className="footer-title">프로덕트</h2>
            <ul className="footer-links">
              {products.map((p) => (
                <li key={p.slug}>
                  <Link to={`/products/${p.slug}`}>{p.nameKo}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h2 className="footer-title">회사</h2>
            <ul className="footer-links">
              {COMPANY_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h2 className="footer-title">법적 고지</h2>
            <ul className="footer-links">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; 2026 Flowto.AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
